// src/i18n/en.ts
export const en = {
  landing: {
    verifying: 'Verifying invitation...',
    invalidTitle: 'Invalid invitation',
    validTitle: 'Valid invitation',
    typeFace: 'Face Enrollment',
    typeAccount: 'Account Creation',
    expires: 'Expires:',
    start: 'Start',
  },
  identity: {
    step: 'Step 1 of 2',
    title: 'Identity verification',
    subtitle: 'Enter the exact details from your ID document.',
    country: 'Country',
    countryPlaceholder: 'Select...',
    idType: 'Document type',
    idTypePlaceholder: 'Select...',
    number: 'Number',
    numberPlaceholder: 'E.g. 12345678',
    verify: 'Verify identity',
    verifying: 'Verifying...',
  },
  enroll: {
    title: 'Face enrollment',
    completed: 'completed',
    of: 'of',
    completionTitle: 'Enrollment complete!',
    completionMessage: 'Do you want to finish the enrollment or modify any image?',
    finish: 'Finish',
    modify: 'Modify',
    positionStart: 'Start',
    infoTitle: 'Prepare your environment',
    infoSubtitle: 'For the best photos, follow these recommendations:',
    infoStand: 'Stand in front of the camera at a distance of 30-50 cm.',
    infoBackground: 'Use a white or neutral colored background.',
    infoLook: 'Look straight at the camera without sunglasses or a cap.',
    infoLight: 'Make sure you have good frontal lighting.',
    infoStart: 'Start enrollment',
    positions: {
      FRONT: { name: 'Front', hint: 'Look straight at the camera', instruction: 'Look straight at the camera keeping your head still' },
      UP: { name: 'Up', hint: 'Tilt your head slightly up', instruction: 'Tilt your head slightly up' },
      DOWN: { name: 'Down', hint: 'Tilt your head slightly down', instruction: 'Tilt your head slightly down' },
      LEFT: { name: 'Left', hint: 'Turn your head slightly to the left', instruction: 'Turn your head slightly to the left' },
      RIGHT: { name: 'Right', hint: 'Turn your head slightly to the right', instruction: 'Turn your head slightly to the right' },
    },
  },
  camera: {
    noFace: 'Bring your face closer to the camera',
    notCentered: 'Center your face in the frame',
    wrongPose: 'Adjust your head position',
    blink: 'Blink once',
    holdPose: 'Hold the pose...',
    perfect: 'Perfect! Capturing...',
    usePhoto: 'Use this photo?',
    retake: 'Retake',
    confirm: 'Use photo',
    uploading: 'Uploading photo...',
    retryUpload: 'Retry upload',
    cameraError: 'Camera problem',
    retry: 'Retry',
  },
  liveness: {
    face: 'Face detected',
    centered: 'Centered',
    pose: 'Correct position',
    blink: 'Blink',
    hold: 'Hold pose',
  },
  account: {
    step: 'Step 2 of 2',
    title: 'Create your password',
    subtitle: 'Set your account password. You will then be able to sign in with your document or email.',
    password: 'Password',
    passwordPlaceholder: 'Minimum 8 characters',
    confirm: 'Confirm password',
    confirmPlaceholder: 'Repeat your password',
    email: 'Email (optional)',
    emailPlaceholder: 'you@email.com',
    emailHint: 'You can use it to sign in and receive notifications.',
    mismatch: 'Passwords do not match',
    tooShort: 'Password must be at least 4 characters long',
    invalidEmail: 'Invalid email format',
    submit: 'Activate account',
    submitting: 'Activating...',
  },
  summary: {
    title: 'Enrollment completed!',
    subtitle: 'Your face was successfully registered.',
    titleAccount: 'Account activated!',
    subtitleAccount: 'Your password was registered. You can now sign in to the platform.',
    finish: 'Finish',
  },
  errors: {
    invalidInvitation: 'Invalid invitation',
    verifyIdentity: 'Error verifying identity',
    activateAccount: 'Error activating account',
    missingContext: 'Missing enrollment context',
  },
} as const